import dialogReciboReducer from './dialogReciboReducer';

export default dialogReciboReducer;